import { TimelineTimeSlotConfigurationsProps } from '@modules/timetable';

export const TimelineTimeSlotConfigurations = ({
  timeSlot,
  leftOffset,
  rightOffset,
  group,
}: TimelineTimeSlotConfigurationsProps) => {
  return (
    <div
      key={`pre-slot-${group.id}-${timeSlot.startTime?.unix().toString()}`}
      id={`${timeSlot.startTime?.unix().toString()}/${timeSlot.endTime?.unix().toString()}`}
      className="time-slot"
      style={{
        left: leftOffset,
        width: rightOffset - leftOffset,
      }}
    />
  );
};
